/**
 * Ids for canvas elements.
 *
 * These used to be minted from `Date.now()` alone, which meant two elements
 * created inside the same millisecond — a fast pair of drops, or two
 * connections drawn in quick succession — got the same id and one of them was
 * silently discarded by React Flow.
 */

let counter = 0;

export function createId(prefix: string): string {
  counter += 1;
  const random = Math.random().toString(36).slice(2, 8);
  return `${prefix}-${Date.now()}-${counter}-${random}`;
}

export const createNodeId = () => createId('node');
export const createEdgeId = () => createId('edge');
export const createAnnotationId = () => createId('annotation');
